import React from 'react';
import { IconProps } from './typing';

const Close = ({ iconSize = 24, color = 'white', background = 'none' }: IconProps) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox="0 0 24 24"
    fill={background}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <path
      d="M21.474 3.467l-.942-.941L12 11.059 3.466 2.526l-.94.941L11.059 12l-8.533 8.532.94.942L12 12.941l8.532 8.533.942-.942L12.941 12z"
      fill={color}
    />
  </svg>
);

export default Close;